"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Login/Quick/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);


var _settings = require('shared/selectors/settings');
var _hooks = require('web/services/hooks');

var _components = require('web/screens/Login/components');
var _UserPicker = require('./UserPicker'); var _UserPicker2 = _interopRequireDefault(_UserPicker);
var _PinForm = require('./PinForm'); var _PinForm2 = _interopRequireDefault(_PinForm);







// Memoized, as connect() was.
const QuickLogin = _react.memo.call(void 0, function QuickLogin ({
  gotoUsernameLogin,
  onRemoveUser,
  onQuickLogin,
}) {
  const quickLoginUsersList = _hooks.useAppSelector.call(void 0, _settings.selectQuickLoginUsersList)
  const [selectedUserKey, setSelectedUserKey] = _react.useState(null)
  const onSelect = (selectedUserKey) => selectedUserKey
    ? setSelectedUserKey(selectedUserKey)
    : gotoUsernameLogin()

  const gotoUsersList = () => setSelectedUserKey(null)

  return (
    _react2.default.createElement(_components.FormWrapper, { title: "Sign in" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 32}}
      ,  !selectedUserKey
        ? _react2.default.createElement(_UserPicker2.default, {
            quickLoginUsersList: quickLoginUsersList,
            onPick: onSelect,
            onRemove: onRemoveUser, __self: this, __source: {fileName: _jsxFileName, lineNumber: 34}}
          )
        : _react2.default.createElement(_PinForm2.default, {
            userKey: selectedUserKey,
            onSubmit: onQuickLogin,
            gotoUsernameLogin: gotoUsernameLogin,
            gotoUsersList: gotoUsersList, __self: this, __source: {fileName: _jsxFileName, lineNumber: 39}}
          )
      
    )
  )
})

exports. default = QuickLogin
